import React from 'react';
import './RenewalDetails.scss';
/** @import {InstructionDetail} from '../MaturityOptionsTypes' */
function DetailsRow(/** @type {InstructionDetail} */{ title, value, additionalInfo }) {
    return (
        <div className={'detailsRow'}>
            <div className={'title_content_data'}>{title}</div>
            <div className={'value'}>{value}</div>
            {additionalInfo && <div className={'additionalInfo'}>{additionalInfo}</div>}
        </div>
    );
}

export default DetailsRow;